module.exports = __webpack_public_path__ + "media/images/logo-f9f4871463abab574bc94efd8e12569f.png";